module.exports = __webpack_public_path__ + "static/screen1-d3779799deb80944e880fb2a86c91db4.png";